
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'commonProgress',
  components: {

  }
})

export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({})
  })progressData!:{};

  @Prop({
    type: Boolean,
    default: false
  })dialogProgressVisible!:Boolean;

  close() {
    this.$emit('close', false);
  }
}
